import { styled, x } from '@xstyled/styled-components';
import React, { FC, useState } from 'react';
import { Link } from 'react-router-dom';
import { t } from 'ttag';
import { usePostReviewMutation } from '~/data';
import { Button } from '~/ui/buttons';
import { Stars } from '~/ui/stars/Stars';
import { useTrainingParams } from '../useTrainingParams';
import { useTrainingUrl } from '../useTrainingUrl';

const StyledLink = styled(Link)`
  text-decoration: underline;
  color: greyDark;
`;

const StarsWrapper = styled.divBox`
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media (max-width: 420px) {
    flex-direction: column;
  }
`;

export const FeedbackForm: FC<{
  postReview: ReturnType<typeof usePostReviewMutation>[0];
}> = ({ postReview }) => {
  const [rating, setRating] = useState<number>();
  const [ratingContent, setRatingContent] = useState<number>();
  const [ratingFunctionality, setRatingFunctionality] = useState<number>();
  const [ratingEngagement, setRatingEngagement] = useState<number>();
  const [comment, setComment] = useState<string>();
  const { learnerTrainingId } = useTrainingParams();
  const url = useTrainingUrl();

  const setOverallRating = (value: number) => {
    if (sessionStorage) {
      sessionStorage.setItem('rating', `${value}`);
    }
    setRating(value);
  };

  return (
    <>
      <p>{t`How would you rate this course?`}</p>
      <StarsWrapper>
        <x.h3 as="div">{t`Overall`}</x.h3>
        <Stars
          name={t`rating`}
          ariaLabel={t`Overall`}
          onChange={setOverallRating}
        />
      </StarsWrapper>
      <StarsWrapper>
        <x.h3 as="div">{t`Content`}</x.h3>
        <Stars
          name={t`content`}
          ariaLabel={t`Content`}
          onChange={setRatingContent}
        />
      </StarsWrapper>
      <StarsWrapper>
        <x.h3 as="div">{t`Functionality`}</x.h3>
        <Stars
          name={t`functionality`}
          ariaLabel={t`Functionality`}
          onChange={setRatingFunctionality}
        />
      </StarsWrapper>
      <StarsWrapper>
        <x.h3 as="div">{t`Engagement`}</x.h3>
        <Stars
          name={t`engagement`}
          ariaLabel={t`Engagement`}
          onChange={setRatingEngagement}
        />
      </StarsWrapper>

      <x.label
        htmlFor="feedback-comment"
        display="block"
        textAlign="left"
        fontSize="14px"
        lineHeight="20px"
      >
        {t`Please provide your honest feedback. It will remain anonymous and will help us improve the training.`}
      </x.label>
      <x.textarea
        id="feedback-comment"
        h="102px"
        p="16px"
        resize="none"
        lineHeight="18px"
        onChange={e => setComment(e.target.value)}
        className="textareaStyleForDarTheme"
      />
      <Button
        disabled={!rating}
        type="button"
        onClick={() => {
          void postReview({
            variables: {
              rating,
              comment,
              ratingContent,
              ratingFunctionality,
              ratingEngagement,
              learnerTrainingUuid: learnerTrainingId!
            }
          });
        }}
      >{t`Send`}</Button>
      <StyledLink
        to={`${url}/success`}
        data-test-id="skip-feedback-link"
      >{t`Or skip this`}</StyledLink>
    </>
  );
};
